import React from 'react';

import { useSelector } from 'react-redux';
import { getScale } from 'containers/App/selectors';
import { ZoomWrapperProps } from './models';
import styles from './styles.module.scss';

const ZoomWrapper: React.FunctionComponent<ZoomWrapperProps> = (props) => {
  const { children, wrapContent = true } = props;
  const scale = useSelector(getScale);

  return (
    <>
      {
        wrapContent
          ? <div className={styles.ZoomWrapper} style={{ transform: `scale(${scale})` }}>
            {children}
          </div>
          : children
      }
    </>
  );
};

export default ZoomWrapper;
